import { render } from "./FactoidsPage.vue?vue&type=template&id=292bfed0&scoped=true"
import script from "./FactoidsPage.vue?vue&type=script&lang=js"
export * from "./FactoidsPage.vue?vue&type=script&lang=js"

import "./FactoidsPage.vue?vue&type=style&index=0&id=292bfed0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-292bfed0"]])

export default __exports__